import { safeProduce as produce } from "~helpers/immer";

import * as at from "./actionTypes";

/**
 * @typedef {object} DeviceItem
 * @property {number} id
 * @property {string} device_id
 * @property {string} device_type
 * @property {string} first_login
 * @property {string} last_activity
 * @property {string} ip_address
 * @property {string} country
 * @property {string} city
 * @property {string} region
 * @property {number} longitude
 * @property {number} latitude
 * @property {boolean} is_active
 * @property {object} metadata
 * @property {string} metadata.os
 * @property {string} metadata.ua
 * @property {string} metadata.type
 * @property {object[]} metadata.brands
 * @property {string} metadata.brands.brand
 * @property {string} metadata.brands.version
 * @property {object} metadata.screen
 * @property {number} metadata.screen.width
 * @property {number} metadata.screen.height
 * @property {number} metadata.screen.availWidth
 * @property {number} metadata.screen.colorDepth
 * @property {number} metadata.screen.pixelDepth
 * @property {number} metadata.screen.availHeight
 * @property {string} metadata.browser
 * @property {string} metadata.language
 * @property {string} metadata.platform
 * @property {string} metadata.timezone
 * @property {number} metadata.deviceMemory
 * @property {string} metadata.browser_version
 * @property {number} metadata.hardwareConcurrency
 * @property {string} registration_id
 * @property {null} push_platform
 * @property {boolean} current_device
 */

export const initState = {
  /** @type {DeviceItem[]} */
  deviceList: [],
};

const device = (state = initState, action) =>
  produce(state, (draft) => {
    switch (action.type) {
      case at.SET_DEVICE_LIST:
        draft.deviceList = action.payload;
        break;
    }
  });

export default device;
